import React, { useEffect, useState } from "react";
import MenuBar from "./MenuBar";
import "../Styles/Business.css";
import { getData } from "../utils/store-data";
import { USER_ID } from "../utils/store-data-constants";
import { get_agent, get_agent_reviews } from "../api/serverWrapper";
import Logo from "../assests/images/profile.png";
import { useMasterData } from "../context/MasterDataContext";
import EditBusiness_set_up from "./EditBusiness_set_up";
import { getDefaultProfileIcon, RatingStars } from "../utils/commonFunctions";
import { useNavigate } from "react-router-dom";

const DEFAULT_PRICING_MODEL = "One time payment";
const DEFAULT_PRICING_AMOUNT = "$12 per 15 matches";
const DEFAULT_PAYMENT_METHODS = ["Bank transfer", "UPI"];

export default function Business() {
  const navigate = useNavigate();
  const {
    religionMasterData,
    allCasteMasterData,
    communityMasterData,
    languageMasterData,
  } = useMasterData();

  const [partner, setPartner] = useState(null);
  const [showEditPage, setShowEditPage] = useState(false);
  const [agentReviews, setAgentReviews] = useState([]);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const defaultPromotionalImages = [
    require("../assests/images/promotional_defalt_icon1.png"),
    require("../assests/images/promotional_defalt_icon2.png"),
    require("../assests/images/promotional_defalt_icon3.png"),
  ];

  useEffect(() => {
    loadInitialData();
  }, []);

  useEffect(() => {
    if (!isGalleryOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setIsGalleryOpen(false);
      }
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [isGalleryOpen]);

  const loadInitialData = async () => {
    try {
      const id = await getData(USER_ID);
      const agent_resp = await get_agent(id);
      console.log("Agent Data:", agent_resp.data);
      setPartner(agent_resp.data);

      loadAgentReviews(id);
    } catch (error) {
      console.log(error);
    }
  };

  const loadAgentReviews = async (id) => {
    try {
      const response = await get_agent_reviews(id);

      console.log("Agent Reviews", response);

      if (response?.code === 200) {
        setAgentReviews(response?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const religionOptions =
    religionMasterData?.map((item) => ({
      value: item.ReligionId,
      label: item.ReligionName,
    })) || [];

  const casteOptions =
    allCasteMasterData?.map((item) => ({
      value: item.CasteL2Id,
      label: item.CasteName,
    })) || [];

  const communityOptions =
    communityMasterData?.map((item) => ({
      value: item.CommunitiesId,
      label: item.CommunitiesName,
    })) || [];

  const languages = languageMasterData || [];

  const pricingModel = partner?.PricingModel || DEFAULT_PRICING_MODEL;
  const pricingAmount = partner?.PricingAmount || DEFAULT_PRICING_AMOUNT;
  const paymentMethods =
    partner?.PaymentMethods?.length > 0
      ? partner.PaymentMethods
      : DEFAULT_PAYMENT_METHODS;
  const businessContactNo = partner?.BusinessContactNo?.trim?.();
  const alternateContactNo = partner?.AlternativeBusinessPhoneNumer?.trim?.();
  const businessEmail = partner?.BusinessEmail?.trim?.();
  const businessWebsite = partner?.BusinessOfficialWebsite?.trim?.();
  const businessWebsiteHref = businessWebsite
    ? /^https?:\/\//i.test(businessWebsite)
      ? businessWebsite
      : `https://${businessWebsite}`
    : "";
  const galleryImages =
    partner?.PromotionalImages?.length > 0
      ? partner.PromotionalImages
      : defaultPromotionalImages;
  const remainingGalleryCount = Math.max(0, galleryImages.length - 4);

  return (
    <div className="wlb-page">
      <MenuBar />

      {partner ? (
        <div className={showEditPage ? "wlb-card wlb-card-edit" : "wlb-card"}>
          {showEditPage ? (
            <div className="wlb-edit-wrapper">
              <EditBusiness_set_up
                existingAgent={partner}
                onClose={() => {
                  setShowEditPage(false);
                  loadInitialData();
                }}
              />
            </div>
          ) : (
            <>
              {/* HEADER */}
              <div className="wlb-header">
                <img
                  src={
                    partner?.User?.ProfilePhotoUrl ||
                    getDefaultProfileIcon(partner?.User)
                  }
                  alt=""
                  className="wlb-avatar"
                />

                <div className="wlb-header-info">
                  <h4 className="wlb-name">{partner?.BusinessName}</h4>

                  <div className="wlb-meta-row">
                    <span className="wlb-meta-item">
                      <span
                        className="wlb-icon wlb-icon-phone"
                        style={{ color: "green" }}
                      >
                        📞
                      </span>
                      Account Status:{" "}
                      <b className="wlb-status-active">Active</b>
                    </span>
                  </div>
                  <div className="wlb-meta-row mt-1">
                    <span className="wlb-meta-item">
                      <span className="wlb-icon">🏢</span>
                      Member Since:{" "}
                      {partner?.User?.CreatedAt
                        ? new Date(partner.User?.CreatedAt).toLocaleDateString(
                            "en-US",
                            { month: "long", year: "numeric" },
                          )
                        : "—"}
                    </span>

                    <span className="wlb-meta-item">
                      <span
                        style={{
                          color: "#f5b301",
                          whiteSpace: "nowrap",
                          fontSize: 16,
                        }}
                      >
                        {" "}
                        ★
                      </span>
                      <b>{partner?.AverageRating ?? "0"}</b> / 5
                      {/* ({partner?.ReviewCount ?? 0} Reviews) */}
                    </span>
                  </div>
                </div>

                <img
                  className="wlb-edit-icon"
                  src={require("../assests/images/edit_business_icon.png")}
                  alt=""
                  onClick={() => setShowEditPage(true)}
                />
              </div>

              {/* PUBLIC LINK */}
              {/* <div className="wlb-link-box">
                <div>
                  <p className="wlb-link-label">Your Public Business Link</p>

                  <a
                    href={`https://web.wedluck.leorobotics.in/browseagents}`}
                    target="_blank"
                    rel="noreferrer"
                    className="wlb-link-url"
                  >
                    https://wedluk.com/agent/{partner?.PublicSlug}
                  </a>
                </div>
                <div className="wlb-link-actions">
                  <button
                    className="wlb-link-btn"
                    onClick={() =>
                      navigator.clipboard.writeText(
                        `https://wedluk.com/agent/browseagents || ""}`,
                      )
                    }
                  >
                    📋 Copy Link
                  </button>
                  <button className="wlb-link-btn">📤 Share Link</button>
                </div>
              </div> */}

              {/* BUSINESS INFORMATION */}
              <div className="wlb-section wlb-section-top">
                <div className="wlb-business-info-heading">
                  <h3 className="wlb-section-title">Business Information</h3>
                  <div className="wlb-business-info-highlights">
                    <div>
                      <span className="wlb-field-label">Reg. No: </span>
                      <span className="wlb-field-value">
                        {partner?.BusinessRegistrationNo ||
                          partner?.AgentId ||
                          "—"}
                      </span>
                    </div>
                    <div>
                      <span className="wlb-field-label">Experience: </span>
                      <span className="wlb-field-value">
                        {partner?.BusinessExperience || 0} Years
                      </span>
                    </div>
                  </div>
                </div>
                <div className="wlb-info-grid">
                  <div>
                    <span className="wlb-field-label">Owner: </span>
                    <span className="wlb-field-value">
                      {partner?.User?.FirstName} {partner?.User?.LastName}
                    </span>
                  </div>
                  <div>
                    <span className="wlb-field-label">Location: </span>
                    <span className="wlb-field-value">
                      {partner?.BusinessAddress || "—"}
                    </span>
                  </div>
                  <div className="wlb-info-full">
                    <span className="wlb-field-label">Contact: </span>
                    <span className="wlb-field-value">
                      +{partner?.User?.CountyCode} {partner?.User?.PhoneNumber}{" "}
                      | {partner?.User?.EMail}
                    </span>
                  </div>
                  {businessContactNo && (
                    <div>
                      <span className="wlb-field-label">
                        Business contact:{" "}
                      </span>
                      <a
                        className="wlb-field-value wlb-field-link"
                        href={`tel:${businessContactNo}`}
                      >
                        {businessContactNo}
                      </a>
                    </div>
                  )}
                  {alternateContactNo && (
                    <div>
                      <span className="wlb-field-label">
                        Alternate contact:{" "}
                      </span>
                      <a
                        className="wlb-field-value wlb-field-link"
                        href={`tel:${alternateContactNo}`}
                      >
                        {alternateContactNo}
                      </a>
                    </div>
                  )}
                  {businessEmail && (
                    <div>
                      <span className="wlb-field-label">Business email: </span>
                      <a
                        className="wlb-field-value wlb-field-link"
                        href={`mailto:${businessEmail}`}
                      >
                        {businessEmail}
                      </a>
                    </div>
                  )}
                  {businessWebsite && (
                    <div className="wlb-info-full">
                      <span className="wlb-field-label">Website: </span>
                      <a
                        className="wlb-field-value wlb-field-link"
                        href={businessWebsiteHref}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {businessWebsite}
                      </a>
                    </div>
                  )}
                </div>
              </div>

              {/* SERVICES PROVIDED */}
              <div className="wlb-section">
                <h3 className="wlb-section-title">Services Provided</h3>

                <div className="wlb-service-row">
                  <span className="wlb-field-label">Religions Served: </span>
                  <span className="wlb-field-value">
                    {partner?.ReligionsServe?.includes("all")
                      ? "All Religions"
                      : religionOptions
                          ?.filter((o) =>
                            partner?.ReligionsServe?.includes(o.value),
                          )
                          ?.map((item) => item.label)
                          ?.join(", ")}
                  </span>
                </div>

                <div className="wlb-service-row">
                  <span className="wlb-field-label">Caste Served: </span>
                  <span className="wlb-field-value">
                    {partner?.CastesServe?.includes("all")
                      ? "All Castes"
                      : casteOptions
                          ?.filter((o) =>
                            partner?.CastesServe?.includes(o.value),
                          )
                          ?.map((item) => item.label)
                          ?.join(", ")}
                  </span>
                </div>

                <div className="wlb-service-row">
                  <span className="wlb-field-label">Communities Served: </span>
                  <span className="wlb-field-value">
                    {partner?.CommunitesServe?.includes("all")
                      ? "All Communities"
                      : communityOptions
                          ?.filter((o) =>
                            partner?.CommunitesServe?.includes(o.value),
                          )
                          ?.map((item) => item.label)
                          ?.join(", ")}
                  </span>
                </div>

                <div className="wlb-service-row">
                  <span className="wlb-field-label">Languages Spoken: </span>
                  <span className="wlb-field-value">
                    {partner?.LanguagesServe?.includes("all")
                      ? "All Languages"
                      : languages
                          ?.filter((o) =>
                            partner?.LanguagesServe?.includes(o.LangId),
                          )
                          ?.map((item) => item.LangDesc)
                          ?.join(", ")}
                  </span>
                </div>
              </div>

              {/* MEDIA GALLERY */}
              <div className="wlb-section">
                <h3 className="wlb-section-title">Media Gallery</h3>
                <div className="wlb-gallery-row">
                  {galleryImages.slice(0, 4).map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt=""
                      className="wlb-gallery-thumb"
                    />
                  ))}
                  {remainingGalleryCount > 0 && (
                    <button
                      type="button"
                      className="wlb-gallery-more"
                      aria-label={`Show all ${galleryImages.length} promotional photos`}
                      onClick={() => setIsGalleryOpen(true)}
                    >
                      +{remainingGalleryCount} More
                    </button>
                  )}
                </div>
                {isGalleryOpen && (
                  <div
                    className="wlb-gallery-modal-overlay"
                    onClick={() => setIsGalleryOpen(false)}
                  >
                    <section
                      className="wlb-gallery-modal"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="wlb-gallery-modal-title"
                      onClick={(event) => event.stopPropagation()}
                    >
                      <header className="wlb-gallery-modal-header">
                        <div>
                          <h2 id="wlb-gallery-modal-title">Media Gallery</h2>
                          <span>{galleryImages.length} photos</span>
                        </div>
                        <button
                          type="button"
                          className="wlb-gallery-modal-close"
                          aria-label="Close gallery"
                          onClick={() => setIsGalleryOpen(false)}
                        >
                          ×
                        </button>
                      </header>
                      <div className="wlb-gallery-modal-grid">
                        {galleryImages.map((img, index) => (
                          <img
                            key={`${img}-${index}`}
                            src={img}
                            alt={`Promotional photo ${index + 1}`}
                          />
                        ))}
                      </div>
                    </section>
                  </div>
                )}
              </div>

              {/* PRICING & PAYMENT */}
              <div className="wlb-section wlb-section-last">
                <h3 className="wlb-section-title">Pricing &amp; Payment</h3>
                <div className="wlb-pricing-row">
                  <span className="wlb-pricing-bullet" />
                  Pricing Model: <b>{pricingModel}</b>
                </div>
                <div className="wlb-pricing-row">
                  <span className="wlb-pricing-bullet" />
                  Service Fee: <b>{pricingAmount}</b>
                </div>
                <div className="wlb-pricing-row">
                  <span className="wlb-pricing-bullet" />
                  Payment Methods: <b>{paymentMethods.join(", ")}</b>
                </div>
                <p className="wlb-note">
                  *These prices are set by the agent for their services
                  independent of Wedluk. Wedluk does not collect or cancel these
                  fees.
                </p>
              </div>

              {/* FOOTER ACTIONS */}
              <div className="wlb-footer">
                <button
                  className="wlb-footer-btn wlb-footer-btn-outline"
                  onClick={() => setShowEditPage(true)}
                >
                  ✎ Edit Profile
                </button>
                <button
                  className="wlb-footer-btn wlb-footer-btn-filled"
                  onClick={() =>
                    navigate("/all-agent-reviews", {
                      state: {
                        agentReviews,
                        partner,
                      },
                    })
                  }
                >
                  View Reviews
                </button>
                {/* <button className="wlb-footer-btn wlb-footer-btn-outline">
                  🔗 Share Profile
                </button>
                <button className="wlb-footer-btn wlb-footer-btn-outline">
                  🔎 Share Profile
                </button> */}
              </div>
            </>
          )}
        </div>
      ) : (
        <div className="wlb-loading">Loading...</div>
      )}
    </div>
  );
}
